import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExternalDataService } from '../external-data/external-data.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalStyleService {
  public $loading = new BehaviorSubject(true);

  // Legacy host-app theme names from the old Aurelia app should be added
  // here once their stylesheets have been ported to /assets/skins/{name}.css.
  private readonly availableSkins = [
    'default', 'open-move', 'siauliai', 'siauliai_dark', 'krauth',
    'tallinn', 'tallinn_dark', 'tartu', 'tartu_dark',
    'elron', 'elron_dark', 'iil', 'iil_dark', 'pilet', 'pilet_dark',
    'legacy_default', 'legacy_tallinn', 'legacy_parnu', 'legacy_emv',
    'legacy_bo', 'legacy_sormland', 'legacy_klaipeda', 'legacy_imatra',
    'legacy_lappeenranta', 'legacy_ytkpohja', 'legacy_vastmanland',
    'legacy_tartu', 'legacy_kolumbus', 'legacy_elron',
  ];
  private currentStylesheet: HTMLLinkElement | null = null;

  constructor(private externalDataService: ExternalDataService) {
    this.externalDataService.$stylesheetName.subscribe((stylesheetName) => {
      this.attachStylesheet(stylesheetName);
    });
  }

  private attachStylesheet(stylesheetName: string) {
    if (!stylesheetName) {
      this.$loading.next(false);
      this.currentStylesheet?.remove();
      this.currentStylesheet = null;
      return;
    }

    // Verify input
    const stylesheetNameFromList = this.availableSkins.find((listItem) => listItem.toLowerCase() === stylesheetName.toLowerCase());
    if (!stylesheetNameFromList) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `./assets/skins/${stylesheetNameFromList}.css`;

    if (this.currentStylesheet?.href === link.href) {
      return;
    }

    link.onload = () => this.$loading.next(false);
    this.$loading.next(true);

    this.currentStylesheet?.remove();
    document.head.appendChild(link);
    this.currentStylesheet = link;
  }
}
